interface NoteSection {
  heading: string | null;
  body: string;
}

const HEADING_PATTERN = /^##\s+(.*)$/;

/**
 * Split work log notes into the sections a synced record writes as markdown headings.
 * Text before the first heading, such as a note typed in the app, keeps no heading.
 */
export const parseNoteSections = (notes: string): NoteSection[] => {
  const sections: NoteSection[] = [];
  let heading: string | null = null;
  let lines: string[] = [];

  const closeSection = () => {
    const body = lines.join('\n').trim();
    if (heading !== null || body) {
      sections.push({ heading, body });
    }
  };

  for (const line of notes.split('\n')) {
    const match = HEADING_PATTERN.exec(line);
    if (!match) {
      lines.push(line);
      continue;
    }
    closeSection();
    heading = match[1].trim();
    lines = [];
  }
  closeSection();

  return sections;
};
